import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=dc5e2ba2&scoped=true"
import script from "./BlockUI.vue?vue&type=script&lang=ts"
export * from "./BlockUI.vue?vue&type=script&lang=ts"
import style0 from "./BlockUI.vue?vue&type=style&index=0&id=dc5e2ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5e2ba2",
  null
  
)

export default component.exports